import { createStore } from 'vuex'

export default createStore({
  state: {
    videoUrlNow: '',
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
